/**
 * Defines the constants used by the AQM module.
 * @file
 * @author Jason Haddix <jason@thebrandingfarm.com>
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 */

// Before starting, generate a hashid and use these to put into  the hash/ take out
export const VUEX_ATTACHMENT_QUEUE_MANAGER_HASH_PUSH_FILE               = 'VUEX_ATTACHMENT_QUEUE_MANAGER_HASH_PUSH_FILE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_HASH_POP_FILE                = 'VUEX_ATTACHMENT_QUEUE_MANAGER_HASH_POP_FILE'

// Internal action/mutation to move the file ids across buckets
export const VUEX_ATTACHMENT_QUEUE_MANAGER_FILE_MOVE_TO_BUCKET          = 'VUEX_ATTACHMENT_QUEUE_MANAGER_FILE_MOVE_TO_BUCKET'

// Actions/mutations used internally to advance the process
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ADD_FILES                    = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ADD_FILES'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_USAGE_TYPE            = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_USAGE_TYPE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_NOTE                  = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_NOTE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_COMMENT_ID            = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_COMMENT_ID'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_UPDATE_FILE_STATUS           = 'VUEX_ATTACHMENT_QUEUE_MANAGER_UPDATE_FILE_STATUS'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_REMOVE_FILE                  = 'VUEX_ATTACHMENT_QUEUE_MANAGER_REMOVE_FILE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_CLEAR_BUCKET                 = 'VUEX_ATTACHMENT_QUEUE_MANAGER_CLEAR_BUCKET'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_REMOVE_HOLDING_FILE          = 'VUEX_ATTACHMENT_QUEUE_MANAGER_REMOVE_HOLDING_FILE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ENQUEUE_UPLOAD               = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ENQUEUE_UPLOAD'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_UPLOAD_FILE                  = 'VUEX_ATTACHMENT_QUEUE_MANAGER_UPLOAD_FILE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_PROCESS_FILE                 = 'VUEX_ATTACHMENT_QUEUE_MANAGER_PROCESS_FILE'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_EVENT_DISPATCHER             = 'VUEX_ATTACHMENT_QUEUE_MANAGER_EVENT_DISPATCHER'

export const VUEX_ATTACHMENT_QUEUE_MANAGER_ATTACH                       = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ATTACH'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_CREATE_JOB_ATTACHMENTS       = 'VUEX_ATTACHMENT_QUEUE_MANAGER_CREATE_JOB_ATTACHMENTS'

// Actions triggered from upload.js
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_S3_KEY                = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ASSIGN_S3_KEY'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_UPLOAD_PROGRESS              = 'VUEX_ATTACHMENT_QUEUE_MANAGER_UPLOAD_PROGRESS'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_HANDLE_UPLOAD_RESULT         = 'VUEX_ATTACHMENT_QUEUE_MANAGER_HANDLE_UPLOAD_RESULT'

// Actions triggered by the files.js API
export const VUEX_ATTACHMENT_QUEUE_MANAGER_FILE_CREATE_SUCCESS          = 'VUEX_ATTACHMENT_QUEUE_MANAGER_FILE_CREATE_SUCCESS'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_FILE_CREATE_FAILURE          = 'VUEX_ATTACHMENT_QUEUE_MANAGER_FILE_CREATE_FAILURE'

// Actions triggered by the attachments.js API
export const VUEX_ATTACHMENT_QUEUE_MANAGER_ATTACH_TO_RESOLUTION_SUCCESS = 'VUEX_ATTACHMENT_QUEUE_MANAGER_ATTACH_TO_RESOLUTION_SUCCESS'

// Used exclusively to trigger the overlay for job uploads
export const VUEX_ATTACHMENT_QUEUE_MANAGER_INIT_JOB_ATTACHMENT          = 'VUEX_ATTACHMENT_QUEUE_MANAGER_INIT_JOB_ATTACHMENT'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_EDIT_JOB_ATTACHMENT          = 'VUEX_ATTACHMENT_QUEUE_MANAGER_EDIT_JOB_ATTACHMENT'

export const VUEX_ATTACHMENT_QUEUE_MANAGER_QUEUE_JOB_ATTACHMENTS        = 'VUEX_ATTACHMENT_QUEUE_MANAGER_QUEUE_JOB_ATTACHMENTS'
export const VUEX_ATTACHMENT_QUEUE_MANAGER_HANDLE_PROCESSING_COMPLETE   = 'VUEX_ATTACHMENT_QUEUE_MANAGER_HANDLE_PROCESSING_COMPLETE'
